import { cleanProductName } from '~~/utils'

export default function ({ app, store, env }) {
  const isProd = env.NODE_ENV === 'production'
  const PIXEL_ID = isProd ? 'C446VTK787TERR100MV0' : 'C446VHK787TERR100MUG'
  generatePixel()

  const { id, email = '' } = store.state.user.details

  if (email) {
    window.ttq.identify({ external_id: id, email })
  }

  app.router.afterEach(() => window.ttq.track('Browse'))

  app.$bus.$on('view-product', () => window.ttq.track('ViewContent'))
  app.$bus.$on('add-cart', product =>
    window.ttq.track('AddToCart', {
      content_id: String(product.id),
      content_type: 'product',
      content_name: cleanProductName(product.name),
      currency: 'USD',
      quantity: 1,
      price: product.price
    })
  )
  app.$bus.$on('register', () => window.ttq.track('Registration'))
  app.$bus.$on('init-checkout', () => window.ttq.track('StartCheckout'))
  app.$bus.$on('place-order', () => window.ttq.track('Checkout'))
  app.$bus.$on('checkout', () => window.ttq.track('Purchase'))

  function generatePixel() {
    const ta = document.createElement('script')
    /* prettier-ignore */
    ta.innerHTML = `!function (w, d, t) { w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};ttq.load('${PIXEL_ID}');ttq.page();}(window, document, 'ttq');`
    ta.type = 'text/javascript'

    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(ta, s)
  }
}
